<ng-container>
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">Billing Adjustment</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-timesheet-filter [filterFields]="fields" [chequeNumbers]="chequeNumbers"
                        (searchEvent)="onSearch($event)"></ppl-timesheet-filter>
                    <p class="pl-2"> <span class="error-message1">*</span> At least one out of the following fields
                        should be populated: <b>Participant Name</b>, <b>Participant PPL ID</b>, <b>Provider Name</b>,
                        <b>Provider PPL ID</b>.
                    </p>
                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For <strong>Adjust Selected</strong> and <strong>Void</strong> actions, please select
                                the applicable timesheet.</li>
                            <li>The <strong>Void All</strong> action will update all timesheets that match the search
                                criteria OR all the selected timesheets.</li>
                        </ul>
                    </div>
                </div>
                <div class="table-style">
                    @if(hasSearched) {
                    <ppl-list-table [cols]="cols" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="timesheets" [customDataLoaded]="true" [enableActions]="false" [from]="'timesheet'"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" [actionButtons]="actionButtons"
                        [enablePageActions]="!isReadOnly" [timesheetFor]="'pendedTimesheet'" [listButton]="isReadOnly ? [] : buttons"
                        (actionInvoked)="gridAction($event)" (onPageLoad)="onPageLoad($event)"
                        [onViewUser]="onViewUserClicked"></ppl-list-table>
                    } @else {
                    <div class="alert alert-warning"><strong>No Records Found. </strong>Please change the filters to
                        find the records</div>
                    }
                </div>
            </div>
        </div>
    </div>
</ng-container>

<div class="filter-panel">
    <ng-template #billingVoidDialog let-cancel="cancel">
        <ppl-timesheet-adjust-void-entry [timesheetData]="billingData" [searchParams]="appliedFilters"
            [source]="'billing'" [actionData]="selectedAction"
            (timesheetAdjustedOrVoided)="timesheetAdjustedOrVoided($event)"></ppl-timesheet-adjust-void-entry>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #billingAdjustOnlyDialog let-cancel="cancel">
        <ppl-timesheet-billing-adjustment-view [selectedBillings]="selectedBillings"
            (onProcessComplete)="timesheetAdjustedOrVoided($event)"></ppl-timesheet-billing-adjustment-view>
    </ng-template>
</div>

<div class="filter-panel">
    <ng-template #searchFilterWarningDialog let-cancel="cancel">
        <p> At least one out of the following fields should be populated: Participant Name, Participant PPL ID, Provider Name,
            Provider PPL ID</p>
    </ng-template>
</div>
